<template>
	<div v-if="$store.hasUserBugReporterRole" class="flex items-center text-yellow-500 cursor-default text-strong-base">
		<BaseIcon name="mono/sparkle" class="mr-8" />
		{{ text }}
	</div>
	<BaseButton
		v-else
		class="link-yellow text-strong-base"
		@click="$routerHelpers.navigateToWorkspaceSettings('subscription-plan')"
	>
		<template #icon>
			<BaseIcon name="mono/sparkle" />
		</template>
		{{ text }}
	</BaseButton>
</template>

<script>
export default {
	computed: {
		trialStatusText() {
			if (this.$workspaceSubscription.hasTrialEnded) return
			const trialDaysLeft = this.$workspaceSubscription.trialDaysLeft
			if (trialDaysLeft === 1) return '1 day left'
			if (trialDaysLeft === 0) return 'last day'
			return `${trialDaysLeft} days left`
		},
		text() {
			return `${this.$workspaceSubscription.plan.name || 'Workspace'} trial: ${
				this.trialStatusText || '...'
			}`.replace('Bug Capture - ', '')
		},
	},
}
</script>
